import type { CartItem } from '@/types';

/**
 * Cart persistence. Uses localStorage so it works for both anonymous and
 * signed-in users with zero backend dependency. Mirrors the
 * `marketplace_cart_items` shape so it can move to Firestore later.
 */
const KEY = 'endeeko.marketplace.cart';
const ABANDON_KEY = 'endeeko.marketplace.cartUpdatedAt';

export const cartService = {
  load(): CartItem[] {
    try {
      return JSON.parse(localStorage.getItem(KEY) ?? '[]') as CartItem[];
    } catch {
      return [];
    }
  },

  save(items: CartItem[]): void {
    localStorage.setItem(KEY, JSON.stringify(items));
    localStorage.setItem(ABANDON_KEY, String(Date.now()));
  },

  clear(): void {
    localStorage.removeItem(KEY);
    localStorage.removeItem(ABANDON_KEY);
  },

  /** Agent 4 — cart-abandonment: ms since the cart was last touched, or null. */
  lastUpdatedAt(): number | null {
    const v = localStorage.getItem(ABANDON_KEY);
    return v ? Number(v) : null;
  },
};
